import { render, staticRenderFns } from "./TheBottomTabs.vue?vue&type=template&id=0d7b5752"
import script from "./TheBottomTabs.vue?vue&type=script&lang=js"
export * from "./TheBottomTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports